import * as React from 'react';
import { Drawer, DrawerContent, DrawerItem } from '@progress/kendo-react-layout';
import { withRouter } from 'react-router-dom';
import { Container } from 'reactstrap';
import NavMenu from './NavMenu'
import AuthService from "../services/auth.service";
import { useTranslation } from "react-i18next";

const CustomItem = (props) => {
    const { visible, ...others } = props;
    const arrowDir = props['data-expanded'] ? 'k-i-arrow-chevron-down' : 'k-i-arrow-chevron-right';

    return (
        <React.Fragment>
            {props.visible === false ? null :
                <DrawerItem {...others} >
                    <span className={'k-icon ' + props.icon} />
                    <span style={{ overflow: "hidden" }} className={'k-item-text'}>{props.text}</span>
                    {props['data-expanded'] !== undefined && <span className={"k-icon " + arrowDir} style={{ position: "absolute", right: 5 }} />}
                </DrawerItem>}
        </React.Fragment>
    );
};

function DrawerRouterContainer(props) {

    const { t } = useTranslation();

    const [items, setItems] = React.useState([]);

    React.useEffect(() => {

        var user = AuthService.getCurrentUser();
        var itemsMenu = [];

        if (user) {

            if (AuthService.isUSerAdmin())

                itemsMenu = [
                    { text: t("Home_Title"), id: 0, icon: 'k-i-home', route: '/' },
                    { separator: true },
                    { text: t("Validation_Title"), id: 1, icon: 'k-i-shape-circle', ['data-expanded']: false },
                    { text: t("Validation_List_Title"), id: 2, parentId: 1, route: '/Validations/' },
                    { separator: true },
                    { text: t("Customer_Title"), id: 3, icon: 'k-i-style-builder', ['data-expanded']: false },
                    { text: t("Customer_List_Title"), id: 4, parentId: 3, route: '/Customers/' },
                    { separator: true },
                    { text: t("User_Title"), id: 5, icon: 'k-i-accessibility', ['data-expanded']: false },
                    { text: t("User_List_Title"), id: 6, parentId: 5, route: '/Users/' }
                ];

            else

                itemsMenu = [
                    { text: t("Home_Title"), id: 0, icon: 'k-i-home', route: '/' },
                    { separator: true },
                    { text: t("Validation_Title"), id: 1, icon: 'k-i-shape-circle', ['data-expanded']: false },
                    { text: t("Validation_List_Title"), id: 2, parentId: 1, route: '/Validations/' }
                ];


        }
        else {
            itemsMenu = [
                { text: t("Home_Title"), id: 0, icon: 'k-i-home', route: '/' }
            ];

        }

        setItems(itemsMenu);

    }, [t]);




    const [state, setState] = React.useState({ drawerExpanded: window.innerWidth > 768, isSmallerScreen: window.innerWidth < 768 });

    const handleClick = () => {
        setState(() => ({ drawerExpanded: !state.drawerExpanded, isSmallerScreen: state.isSmallerScreen }));
    };

    const onSelect = (ev) => {
        const currentItem = ev.itemTarget.props;
        const isParent = currentItem['data-expanded'] !== undefined;
        const nextExpanded = !currentItem['data-expanded'];

        const newData = items.map((item) => {
            const { selected, ['data-expanded']: currentExpanded, id, ...others } = item;
            const isCurrentItem = currentItem.id === id;
            return {
                selected: isCurrentItem,
                ['data-expanded']: isCurrentItem && isParent ? nextExpanded : currentExpanded,
                id,
                ...others
            };
        });

        if (!isParent && (window.innerWidth < 768))
            setState({ drawerExpanded: !state.drawerExpanded, isSmallerScreen: state.isSmallerScreen });

        setItems(newData);
        props.history.push(ev.itemTarget.props.route);
    }


    const data = items.map((item) => {
        const { parentId, ...others } = item;
        if (parentId !== undefined) {
            const parent = items.find(parent => parent.id === parentId)
            return {
                ...others,
                visible: parent['data-expanded']
            };
        }
        return item;
    });

    return (
        <div>
            <NavMenu onButtonClick={handleClick} />
            <Drawer
                expanded={state.drawerExpanded}
                mode={state.isSmallerScreen ? 'overlay' : 'push'}
                style={{ height: "100vh" }}
                items={data}
                position='start'
                item={CustomItem}
                onSelect={onSelect}
            >
                <DrawerContent>
                    <div>
                        <Container>
                            {props.children}
                        </Container>
                    </div>
                </DrawerContent>
            </Drawer>
        </div >
    );

};

export default withRouter(DrawerRouterContainer);
